export class CanvasProvider {
    constructor() {
        Object.defineProperty(this, "objects", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "pool", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    createCanvas(width, height) {
        let canvas = this.pool.shift();
        if (!canvas) {
            canvas = document.createElement('canvas');
            this.objects.push(canvas);
        }
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    disposeCanvas(canvas) {
        if (canvas && this.objects.indexOf(canvas) !== -1) {
            canvas.width = 0;
            canvas.height = 0;
            this.pool.push(canvas);
        }
    }
    dispose() {
        this.objects.forEach(canvas => {
            canvas.width = 0;
            canvas.height = 0;
        });
        this.pool.splice(0, this.pool.length);
        this.objects.splice(0, this.objects.length);
    }
}
